/**
 * Created by tofaelraju on 3/25/17.
 */

import React from 'react';
import Snackbar from 'material-ui/Snackbar';

const FeedbackBar =({notifyUser, notificationMessage, closeFeedbackBar})=>(
  <Snackbar
    action="close"
    open={notifyUser}
    message={notificationMessage}
    onRequestClose={closeFeedbackBar}
    onActionTouchTap={closeFeedbackBar}
  />
);

export default FeedbackBar;


// WEBPACK FOOTER //
// ./src/screens/layout/feedback-bar.js